const underwearMen = [
  { title: "Boxers", icon: "icon1", subcategories: [] },
  { title: "Briefs", icon: "icon2", subcategories: [] },
  { title: "Undershirts", icon: "icon2", subcategories: [] },
];

export default underwearMen;
